module.exports={
  "tilde": {
    "path": "M.076 36.563c-3.77-.558 134.472-76.77 183.685-7.485 41.218 58.034 15.895 120.156 41.387 154.167 25.493 34.01 57.527 47.312 58.829 49.059 1.303 1.748-52.57 48.143-130.151-40.397C76.246 103.368 112.032 53.135.076 36.563",
    "width": 284,
    "height": 248
  },
  "leaf": {
    "path": "M64.207 287.17c1.965-2.757 36.193-25.498 23.028-45.928C74.07 220.812-22.855 131.176 5.005 70.69 32.866 10.2 63.166-7.027 123.07 12.009 182.974 31.046 200.583 39.405 242.53 0l13.785.108s-41.539 46.614-22.038 85.387c19.499 38.773 90.04 58.446 30.007 115.45 0 0-17.443 17.817-68.243 17.95-44.107.115-75.977 24.912-91.428 48.538C89.16 291.059 84.965 295 84.965 295l-20.758-7.83z",
    "width": 288,
    "height": 295
  },
  "golf_club": {
    "path": "M407.752 369.25c-.474.157-.947.292-1.419.433-29.15 8.889-59.245-4.672-59.245-4.672-73.49-35.51-95.365-118.979-102.2-136.964-6.838-17.983-12.078-42.704-38.519-119.13-26.446-76.428-44.785-98.402-68.543-106.612-23.758-8.21-46.996 8.147-46.996 8.147-61.458 40.217-79.145 95.935-79.145 95.935l-.239.5c-24.18 59.944-5.137 119.191 12.03 151.96 2.26 4.308 4.486 8.18 6.578 11.512 17.983 28.686 67.276 105.644 211.782 153.623 31.84 10.575 60.463 15.154 85.747 15.88 30.659.88 56.4-3.92 76.999-10.607 39.52-12.825 60.1-32.601 60.1-32.601l-56.93-27.403z",
    "width": 465,
    "height": 440
  },
  "droplet": {
    "path": "M91.832 26.033s8.878 17.74 16.682 49.572c7.802 31.834 10.32 48.128 7.156 70.996-3.162 22.868-10.72 38.394-24.673 43.918-13.953 5.523-30.968 7.09-51.785-1.999C18.396 179.433 4.775 155.788.59 115.617c-4.183-40.17 15.127-90.643 18.449-99.135 3.32-8.491 52.399-37.13 72.793 9.55",
    "width": 117,
    "height": 195
  },
  "boomerang": {
    "path": "M152 48.755c-3.612 1.297-60.159 40.253-69.85 34.704C72.46 77.91 2.748 11.844.28 3.703-2.186-4.439 11.864.778 33.712 20.016c21.848 19.239 35.394 35.712 51.127 34.17 15.734-1.542 48.589-17.253 63.831-8.236 2.799 1.655 3.33 2.805 3.33 2.805",
    "width": 152,
    "height": 84
  },
  "blob": {
    "path": "M.99 182.256s-3.042-68.72 1.539-82.132c9.269-27.135 49.994-62.52 61.116-74.129C74.765 14.388 111.84 1.887 136.863.101c25.025-1.785 86.193 20.537 99.169 33.038 12.975 12.5 22.801 36.61 31.79 64.29 8.989 27.68 15.109 69.647 0 96.434-15.108 26.788-44.766 67.862-78.131 80.364-33.365 12.5-131.025 11.607-151.707-15.18C17.304 232.258.99 182.255.99 182.255",
    "width": 277,
    "height": 282
  },
  "blobby": {
    "path": "M.226 108.952c.21-1.735 10.681-61.86 16.541-71.047 5.86-9.189 13.914-25.439 42.267-35.188 28.354-9.75 67.715 7.975 96.365 33.511 28.65 25.536 41.122 49.212 31.272 82.064-9.85 32.852-51.166 54.24-92.395 52.622-41.228-1.617-76.643-16.213-82.611-20.6-5.968-4.387-13.023-28.282-11.44-41.362",
    "width": 190,
    "height": 171
  },
  "smudge": {
    "path": "M411 0S269.408 1.972 219.476 62.852c-49.933 60.88-153.404 179.46-204.61 309.551-51.205 130.094 32.052 195.012 216.068 144.392 184.016-50.62 179.95-511.63 179.95-511.63",
    "width": 411,
    "height": 534
  },
  "overlay": {
    "path": "M214.853 432.266c158.96 27.582 416.272-230.95 379.617-324.09C569.264 44.129 397.403-10.863 161.503 1.839 110.405 4.59 36.657 67.891.003 103.458c0 0-2.988 291.01 214.85 328.808z",
    "width": 598,
    "height": 435
  },
  "rock": {
    "path": "M50.913,54.839c0,0-68.48,80.637-46.599,115.079c29.581,36.874,169.783,25.123,208.682,7.294\n\tc21.882-19.45,47.004-49.03,47.004-49.03S246.223,11.887,155.456,0.541C106.426-6.347,50.913,54.839,50.913,54.839z",
    "width": 260,
    "height": 195
  }
}
